import { Box, Stack, Typography } from "@mui/material";
import { DataImportCellError } from "../DataImport.interfaces";

interface ErrorPanelProps {
  errors: DataImportCellError[];
}

export function ErrorPanel({ errors }: ErrorPanelProps) {
  if (errors.length === 0) return null;

  return (
    <Box sx={{ border: "1px solid", borderColor: "error.light", borderRadius: 1.5, overflow: "hidden", bgcolor: "error.lighter" }}>
      <Box sx={{ px: 1.5, py: 1, borderBottom: 1, borderColor: "error.light", bgcolor: "error.main" }}>
        <Typography variant="caption" sx={{ fontWeight: 700, color: "white", textTransform: "uppercase" }}>
          Error Log ({errors.length})
        </Typography>
      </Box>
      <Stack spacing={0} sx={{ maxHeight: 180, overflow: "auto", p: 0.5 }}>
        {errors.slice(0, 50).map((error, index) => (
          <Box
            key={`${error.rowIndex}-${error.fieldKey}-${index}`}
            sx={{
              display: "flex",
              gap: 1,
              p: 0.75,
              borderBottom: "1px dashed",
              borderColor: "error.light",
              "&:last-child": { borderBottom: "none" },
            }}
          >
            <Typography variant="caption" fontWeight={700} color="error.main" sx={{ minWidth: 45 }}>
              Row {error.rowIndex + 1}
            </Typography>
            <Typography variant="caption" color="error.dark">
              <strong>{error.fieldLabel}:</strong> {error.message}
            </Typography>
          </Box>
        ))}
        {errors.length > 50 && (
          <Typography variant="caption" color="text.secondary" sx={{ p: 1, textAlign: "center" }}>
            Showing first 50 errors...
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
